import React, { Fragment, FunctionComponent } from "react";

import { BLOCK_TYPE } from "app/blocks/block.types";

import { Accordions, AccordionsProps } from "blocks/components/Accordions";
import { Banner, BannerProps } from "blocks/components/Banner";
import { Cards, CardsProps } from "blocks/components/Cards";
import { DownloadLinks, DownloadLinksProps } from "blocks/components/DownloadLinks";
import { Embed, EmbedProps } from "blocks/components/Embed";
import { Employees, EmployeesProps } from "blocks/components/Employees";
import { Events, EventsProps } from "blocks/components/Events";
import { Form, FormProps } from "blocks/components/Form";
import { Image, ImageProps } from "blocks/components/Image";
import { Logos, LogosProps } from "blocks/components/Logos";
import { LogosSponsors, LogosSponsorsProps } from "blocks/components/LogosSponsors";
import { News, NewsProps } from "blocks/components/News";
import { Quote, QuoteProps } from "blocks/components/Quote";
import { QuoteSlideshow, QuoteSlideshowProps } from "blocks/components/QuoteSlideshow";
import { Spots, SpotsProps } from "blocks/components/Spots";
import { Text, TextProps } from "blocks/components/Text";
import { TextImage, TextImageProps } from "blocks/components/TextImage";
import { TextVideo, TextVideoProps } from "blocks/components/TextVideo";
import { Video, VideoProps } from "blocks/components/Video";

const ContentPageBlock: FunctionComponent<BLOCK_TYPE> = (props) => {
    const renderControl = (props: BLOCK_TYPE): null | JSX.Element => {
        switch (props?.content?._contentType) {
            case "blockAccordions": {
                return (
                    <Accordions {...props as AccordionsProps} />
                );
            }
            case "blockBanner": {
                return (
                    <Banner {...props as BannerProps} />
                );
            }
            case "blockCardsCarousel": {
                return (
                    <Cards {...props as CardsProps} />
                );
            }
            case "blockDownloadLinksList": {
                return (
                    <DownloadLinks {...props as DownloadLinksProps} />
                );
            }
            case "blockEmbed": {
                return (
                    <Embed {...props as EmbedProps} />
                );
            }
            case "blockEmployeesList": {
                return (
                    <Employees {...props as EmployeesProps} />
                );
            }
            case "blockEventsList": {
                return (
                    <Events {...props as EventsProps} />
                );
            }
            case "blockImage": {
                return (
                    <Image {...props as ImageProps} />
                );
            }
            case "blockLogosList": {
                return (
                    <Logos {...props as LogosProps} />
                );
            }
            case "blockLogosSponsors": {
                return (
                    <LogosSponsors {...props as LogosSponsorsProps} />
                );
            }
            case "blockNewsList": {
                return (
                    <News {...props as NewsProps} />
                );
            }
            case "blockQuote": {
                return (
                    <Quote {...props as QuoteProps} />
                );
            }
            case "blockQuoteSlideshow": {
                return (
                    <QuoteSlideshow {...props as QuoteSlideshowProps} />
                );
            }
            case "blockSpots": {
                return (
                    <Spots {...props as SpotsProps} />
                );
            }
            case "blockText": {
                return (
                    <Text {...props as TextProps} />
                );
            }
            case "blockTextImage": {
                return (
                    <TextImage {...props as TextImageProps} />
                );
            }
            case "blockTextVideo": {
                return (
                    <TextVideo {...props as TextVideoProps} />
                );
            }
            case "blockVideo": {
                return (
                    <Video {...props as VideoProps} />
                );
            }
            case "blockForm": {
                return (
                    <Form {...props as FormProps} />
                );
            }
            default: {
                return null;
            }
        }
    };

    return (
        <Fragment>
            {renderControl(props)}
        </Fragment>
    );
};

export default ContentPageBlock;